import {
    AlertTriangle, Shield, Target, Zap, Crosshair,
    SplitSquareVertical, Fingerprint, Compass
} from 'lucide-react';

export const CHAPTERS = [
    {
        num: 1, title: 'Autoexploración', subtitle: 'Reconocer patrones',
        color: '#3E5F6E', accent: '#425A65',
        moduleIds: ['diferencial_inicial', 'registro_episodios', 'semaforo_funcional', 'doble_capa', 'linea_base'],
        insights: [
            { key: 'diferencial', label: 'Tipo diferencial', field: 'insight_usuario' },
            { key: 'linea_base', label: 'Perfil consolidado', field: 'insight_usuario' }
        ],
        summaryPath: '/usuario/resumen-capitulo-1'
    },
    {
        num: 2, title: 'Amenaza y Defensa', subtitle: 'Comprender el ciclo',
        color: '#3E5F6E', accent: '#5FAF9D',
        moduleIds: ['mapa_amenaza', 'radar_exigencia', 'contrato_oculto', 'arbol_temor', 'radiografia'],
        profileFields: [
            { key: 'amenaza_central', label: 'Amenaza central', icon: AlertTriangle, color: '#E8B27A' },
            { key: 'defensa_principal', label: 'Defensa', icon: Shield, color: '#3E5F6E' },
            { key: 'temor_raiz', label: 'Temor raíz', icon: Target, color: '#D07F7E' },
            { key: 'decision_correctiva', label: 'Decisión correctiva', icon: Zap, color: '#5FAF9D' }
        ],
        summaryPath: '/usuario/resumen-capitulo-2'
    },
    {
        num: 3, title: 'Foco y Acción', subtitle: 'Actuar con claridad',
        color: '#5FAF9D', accent: '#4A9A89',
        moduleIds: ['inventario_frentes', 'deber_prestado', 'filtro_impacto', 'tarea_faro_3', 'dai'],
        daiFields: [
            { key: 'tarea_faro', label: 'Tarea faro', icon: Crosshair },
            { key: 'primera_accion', label: 'Primera acción', icon: Zap },
        ],
        summaryPath: '/usuario/resumen-capitulo-3'
    },
    {
        num: 4, title: 'Intervención y Automatización', subtitle: 'De la comprensión a la acción automática',
        color: '#3E5F6E', accent: '#2F4A57',
        moduleIds: ['descomposicion_momento', 'microsenales', 'reescritura', 'intervencion_vivo', 'automatizacion'],
        habitFields: [
            { key: 'disparador_microsenal', label: 'Disparador', icon: SplitSquareVertical, color: '#D07F7E' },
            { key: 'accion_elegida', label: 'Acción elegida', icon: Zap, color: '#5FAF9D' },
        ],
        summaryPath: '/usuario/resumen-capitulo-4'
    },
    {
        num: 5, title: 'Ejecución sin fricción', subtitle: 'Activar sin resistencia',
        color: '#4A9A89', accent: '#3E8A7A',
        moduleIds: ['detector_friccion', 'vmv', 'diseno_entorno', 'arranque_obligatorio', 'sistema_ejecucion'],
        summaryPath: '/usuario/resumen-capitulo-5'
    },
    {
        num: 6, title: 'Sostenimiento y progreso', subtitle: 'Mantener el avance',
        color: '#5FAF9D', accent: '#4A9A89',
        moduleIds: ['registro_accion', 'cadena_ejecucion', 'escala_ajuste', 'metricas_funcionales', 'ciclo_progreso'],
        summaryPath: '/usuario/resumen-capitulo-6'
    },
    {
        num: 7, title: 'Evaluación y rediseño', subtitle: 'Ajustar lo que no funciona',
        color: '#3E5F6E', accent: '#5FAF9D',
        moduleIds: ['evaluacion_funcional', 'mapa_patrones', 'punto_intervencion', 'rediseno_patron', 'mapa_decision'],
        summaryPath: '/usuario/resumen-capitulo-7'
    },
    {
        num: 8, title: 'Revisión y sistema autónomo', subtitle: 'Construir autonomía',
        color: '#2F4A57', accent: '#3E5F6E',
        moduleIds: ['diagnostico_sostenibilidad', 'reinicio_rapido', 'proteccion_recaidas', 'refuerzo_inteligente', 'sistema_autonomo'],
        summaryPath: '/usuario/resumen-capitulo-8'
    },
    {
        num: 9, title: 'Integración y cierre', subtitle: 'Consolidar la identidad operativa',
        color: '#3E5F6E', accent: '#4A9A89',
        moduleIds: ['senales_integracion', 'transferencia_sistema', 'criterio_propio', 'identidad_operativa', 'vision_operativa'],
        profileFields: [
            { key: 'identidad_operativa', label: 'Identidad operativa', icon: Fingerprint, color: '#3E5F6E' },
            { key: 'vision_operativa', label: 'Visión operativa', icon: Compass, color: '#5FAF9D' },
        ],
        summaryPath: '/usuario/resumen-capitulo-9'
    }
];
